<template>
  <el-row>
    <table-template :queryParams="queryParams"   actionUrl="/businessIntranet/findActionRecordList.action"
                    ref="actionRecordManagementTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange(queryParams.startEndTime,1)"
                  end-placeholder="操作结束日期"
                  range-separator="至"
                  start-placeholder="操作开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange(queryParams.startEndRegisterTime,2)"
                  end-placeholder="注册结束日期"
                  range-separator="至"
                  start-placeholder="注册开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndRegisterTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>

            <el-select  @change="$refs.actionRecordManagementTable.search()" clearable placeholder="是否有邀请人"
                        v-model="queryParams.ifInviter">
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="无邀请人"></el-option>
              <el-option :value="2" label="有邀请人"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item>
              <el-select  @change="$refs.actionRecordManagementTable.search()" clearable placeholder="是否有维护人"
                          v-model="queryParams.ifMainTennace">
                <el-option :value="null" label="全部"></el-option>
                <el-option :value="1" label="无维护人"></el-option>
                <el-option :value="2" label="有维护人"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <employee-select @clear="clear" @onEmployeeSelected="onEmployeeSelectedQuery"
                               placeholder="请选择维护人"></employee-select>
            </el-form-item>
            <el-form-item>
              <el-select  @change="$refs.actionRecordManagementTable.search()" clearable placeholder="会员类型"
                          v-model="queryParams.memberType">
                <el-option :value="1" label="普通用户"></el-option>
                <el-option :value="3" label="卖车通会员"></el-option>
                <el-option :value="5" label="买卖通会员"></el-option>
                <el-option :value="6" label="专享通会员"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="queryParams.actionContent" :clearable="true" :filterable="true" placeholder="行为类型">
                <el-option value="访问普通线索详情" label="访问普通线索详情"></el-option>
                <el-option value="访问专区线索详情" label="访问专区线索详情"></el-option>
                <el-option value="收车线索联系车主" label="收车线索联系车主"></el-option>
                <el-option value="收车线索电话拨打" label="收车线索电话拨打"></el-option>
                <el-option value="访问车源详情" label="访问车源详情"></el-option>
                <el-option value="车源电话联系" label="车源电话联系"></el-option>
                <el-option value="车源分享" label="车源分享"></el-option>
                <el-option value="访问求购详情" label="访问求购详情"></el-option>
                <el-option value="求购电话联系" label="求购电话联系"></el-option>
                <el-option value="访问会员详情" label="访问会员详情"></el-option>
                <el-option value="卖车通会员" label="卖车通会员"></el-option>
                <el-option value="买卖通会员" label="买卖通会员"></el-option>
                <el-option value="专享通会员" label="专享通会员"></el-option>
                <el-option value="访问专享通详情" label="访问专享通详情"></el-option>
                <el-option value="点击开通加入群聊" label="点击开通加入群聊"></el-option>
                <el-option value="访问朋友圈车源介绍" label="访问朋友圈车源介绍"></el-option>
                <el-option value="点击手动发布朋友圈车源" label="点击手动发布朋友圈车源"></el-option>
                <el-option value="点击开通微信同步" label="点击开通微信同步"></el-option>
                <el-option value="点击发布车源" label="点击发布车源"></el-option>
                <el-option value="专区线索预约看车" label="专区线索预约看车"></el-option>
                <el-option value="朋友圈车源添加微信" label="朋友圈车源添加微信"></el-option>
                <el-option value="朋友圈车源电话联系" label="朋友圈车源电话联系"></el-option>
                <el-option value="访问朋友圈车源" label="访问朋友圈车源"></el-option>
                <el-option value="访问微店" label="访问微店"></el-option>
                <el-option value="点击添加人脉" label="点击添加人脉"></el-option>

                <el-option value="访问充值保证金" label="访问充值保证金"></el-option>
                <el-option value="访问私聊窗口" label="访问私聊窗口"></el-option>

                <el-option value="访问查行情" label="访问查行情"></el-option>
                <el-option value="分享查行情" label="分享查行情"></el-option>

              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select v-model="queryParams.sortType" :filterable="true" placeholder="排序规则">
                <el-option :value="1" label="操作时间就近"></el-option>
                <el-option :value="2" label="操作次数由大到小"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-input placeholder="用户手机号" v-model="queryParams.userPhone"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="邀请人手机号" v-model="queryParams.inviterPhone"></el-input>
            </el-form-item>
            <el-form-item >
              <el-switch v-model="queryParams.group"  active-text="去重" :active-value="1"  :inactive-value="null"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.actionRecordManagementTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="用户信息"
            prop="">
          <template scope="scope">
            {{scope.row.name}}-{{scope.row.phone}}
          </template>
        </el-table-column>
        <el-table-column
            label="会员类型"
            prop="">
          <template scope="scope">
            {{scope.row.type|memberTypeFilter}}
          </template>
        </el-table-column>
        <el-table-column
            label="注册时间">
          <template scope="scope">
            {{scope.row.registerMemberTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
            label="邀请人信息"
            prop="inviterEmployeeName">
          <template scope="scope" >
            <span v-if="scope.row.inviterEmployeePhone"> {{scope.row.inviterEmployeeName}}-{{scope.row.inviterEmployeePhone}}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="维护人"
            prop="maintenanceName">
        </el-table-column>
        <el-table-column
            label="操作行为"
            prop="accountContent">
        </el-table-column>
        <el-table-column
            label="累计行为次数"
            prop="total">
        </el-table-column>
        <el-table-column
            label="操作时间">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template scope="scope">
            <el-button type="text" size="mini" @click="$router.push({path:'/home/distributionBusinessMaintenanceEmployee',query:{'businessId':scope.row.businessId}})">分配维护人</el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  components: {
    TableTemplate,
    EmployeeSelect
  },
  extends: BasicPager,
  name: 'actionRecordManagement',
  data: function () {
    return {
      queryParams: {
        group: null,
        sortType: 1,
        userPhone: null,
        inviterPhone: null,
        maintenanceEmployeeSnapId: null,
        ifInviter: null,
        ifMainTennace: null,
        actionContent: null,
        memberType: null,
        startEndRegisterTime: null,
        startEndTime: null
      }
    }
  },
  watch: {
    'queryParams.userPhone': function (val) {
      if (val === '') {
        this.queryParams.userPhone = null
      }
    },
    'queryParams.inviterPhone': function (val) {
      if (val === '') {
        this.queryParams.inviterPhone = null
      }
    },
    'queryParams.sortType': function (val) {
      if (val === '') {
        this.queryParams.sortType = null
      }
      this.$refs.actionRecordManagementTable.search()
    },
    'queryParams.group': function (val) {
      this.$refs.actionRecordManagementTable.search()
    },
    'queryParams.actionContent': function (val) {
      if (val === '') {
        this.queryParams.actionContent = null
      }
      this.$refs.actionRecordManagementTable.search()
    }
  },
  activated: function () {
    this.$refs.actionRecordManagementTable.search()
  },

  methods: {
    clear: function () {
      this.queryParams.maintenanceEmployeeSnapId = null
      this.$refs.actionRecordManagementTable.search()
    },
    onEmployeeSelectedQuery: function (item) {
      this.queryParams.maintenanceEmployeeSnapId = item.snapshotId
      this.$refs.actionRecordManagementTable.search()
    },
    onDateTimeChange (dates, type) {
      switch (type) {
        case 1:
          if (dates && dates.length === 2) {
            this.queryParams.startTime = dates[0].getTime()
            this.queryParams.endTime = dates[1].getTime()
          } else {
            this.queryParams.startTime = null
            this.queryParams.endTime = null
          }
          break
        case 2:
          if (dates && dates.length === 2) {
            this.queryParams.startRegisterTime = dates[0].getTime()
            this.queryParams.endRegisterTime = dates[1].getTime()
          } else {
            this.queryParams.startRegisterTime = null
            this.queryParams.endRegisterTime = null
          }
      }

      this.$refs.actionRecordManagementTable.search()
    }
  },
  filters: {
    memberTypeFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '普通用户'
          break
        case 2:
          str = '卖车通365会员'
          break
        case 3:
          str = '卖车通会员'
          break
        case 4:
          str = '收车通会员'
          break
        case 5:
          str = '买卖通会员'
          break
        case 6:
          str = '专享通会员'
          break
        default:
          str = '普通用户'
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
